export default "__VITE_ASSET__CyLxAPc5__"